var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperationBorm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 11.875C6.25 13.6 8.76875 15 11.875 15C14.9812 15 17.5 13.6 17.5 11.875C17.5 10.15 14.9812 8.75 11.875 8.75C8.76875 8.75 6.25 10.15 6.25 11.875Z",
    stroke: "#186419",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20.8087C17.5 22.4337 14.9812 23.75 11.875 23.75C8.76875 23.75 6.25 22.4337 6.25 20.8087V11.875M17.5 11.875V16.875M11.875 11.875H11.8638M2.5 22.5L27.5 13.75M2.5 17.5L6.25 15.8125M27.5 6.25L17.5 10.75",
    stroke: "#186419",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationBorm);
export default __webpack_public_path__ + "static/media/OperationBORM.ca2bb29ceb065e1f33679506363f96b4.svg";
export { ForwardRef as ReactComponent };